<template>
    <div class="tree-filter-header">
        <div class="title-box" v-show="!treeFilter">
            <span>{{title}}</span>
            <div class="icon-box">
                <Icon type="ios-search" @click="handleShowTreeFilterInput" />
                <Icon
                    type="ios-add-circle-outline"
                    @click="handleAddRootDeptPop"
                />
            </div>
        </div>
        <div class="input-box" v-show="treeFilter">
            <Input
                v-model="deptFilterStr"
                prefix="ios-search"
                size="large"
                placeholder="请输入关键词"
                ref="filterInput"
                @on-change="deptListFilter"
            />
            <Icon type="ios-close" @click="cancelDeptFilter" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            treeFilter: false,
            deptFilterStr: '',
        }
    },
    props: {
        title: {
            default: '',
            type: String
        }
    },
    methods: {
        handleShowTreeFilterInput() {
            this.treeFilter = true
            this.$nextTick(() => {
                this.$refs.filterInput.focus()
            })
        },
        cancelDeptFilter() {
            this.deptFilterStr = ''
            this.treeFilter = false
            this.$emit('handelSearch', this.deptFilterStr);
            // this.$refs.encTree.cancelFilter()
        },
        handleAddRootDeptPop() {
            this.$emit('handelAdd');
        },
        deptListFilter() {
            this.$emit('handelSearch', this.deptFilterStr);
        }
    },
}
</script>

<style lang="less">
.tree-filter-header{
    position: relative;
    height: 72px;
    line-height: 72px;
    font-size: 16px;
    .title-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .icon-box{
            display: flex;
            align-items: center;
        }
        .ivu-icon{
            color: var(--theme-menu-item-selected-bg-color);
            font-size: 20px;
            font-weight: 700;
            cursor: pointer;
            width: 46px;
            height: 46px;
            line-height: 46px;
        }
    }
    .input-box{
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        .ivu-input-wrapper{
            position: absolute;
            width: 100%;
        }
        .ivu-icon-ios-close{
            font-size: 30px;
            position: absolute;
            right:2px;
            top:21px;
            cursor: pointer;
        }
    }
    .ivu-input-prefix i, .ivu-input-suffix i{
        color: var(--theme-menu-item-selected-bg-color);
    }
}
</style>
